import { jsx as _jsx } from "react/jsx-runtime";
export function EditorLink({ editor, enforceProspectMode, className }) {
    if (enforceProspectMode && !editor.verified) {
        throw new Error(`EditorLink: "${editor.displayName}" (id=${editor.id}) is not a verified real person and cannot appear on a prospect-mode surface. Contract C12 blocks this render.`);
    }
    return (_jsx("a", { href: editor.profileUrl, className: className, "data-editor-link": true, "data-real-person": editor.verified ? 'true' : 'false', target: "_blank", rel: "noopener noreferrer", title: editor.credentials.join(' · '), "aria-label": `${editor.displayName} — ${editor.credentials.join('; ')}`, style: {
            color: 'var(--text)',
            textDecoration: 'underline',
            textDecorationColor: 'var(--border-strong)',
            textUnderlineOffset: '2px',
            fontFamily: 'var(--font-ui)',
        }, children: editor.displayName }));
}
//# sourceMappingURL=EditorLink.js.map